import React from 'react';

const Indicator = ({formIndex}) => {
    const proofActive = formIndex === 1 || formIndex === 2;
    const proofDone = formIndex > 2;
    const attestActive = formIndex === 3 || formIndex === 4;
    const attestDone = formIndex > 4;
    const hostIdActive = formIndex === 5 || formIndex === 6;
    const hostIdDone = formIndex > 6;
    const confirmActive = formIndex === 7;

    return (
        <div className={'flex justify-around mb-8'}>
            <div className={`pt-4 w-36 text-left ft-sm font-medium text-gray-900 border-t-4
            ${proofActive ? 'border-yellow-200' : proofDone ? 'border-yellow-500' : ''}`}>
                Justificatif de domicile
            </div>
            <div className={`pt-4 w-36 text-left ft-sm font-medium text-gray-900 border-t-4
            ${attestActive ? 'border-yellow-200' : attestDone ? 'border-yellow-500' : ''}`}>
                Attestation de logement
            </div>
            <div className={`pt-4 w-36 text-left ft-sm font-medium text-gray-900 border-t-4
            ${hostIdActive ? 'border-yellow-200' : hostIdDone ? 'border-yellow-500' : ''}`}>
                Pièce d'identité de l'hôte
            </div>
            <div className={`pt-4 w-36 text-left ft-sm font-medium text-gray-900 border-t-4
            ${confirmActive ? 'border-yellow-200' : ''}`}>
                Confirmation
            </div>
        </div>
    );
};

export default Indicator;